import React, { useState } from "react";
import { Container } from "react-bootstrap";

import { useUser } from "../firebase";

const DangerBar = () => {
  const { user } = useUser();
  const [clicked, setClicked] = useState(false);
  const [sent, setSent] = useState(false);
  const handleClick = async () => {
    if (!clicked) {
      setClicked(true);
      await user.sendEmailVerification();
      setSent(true);
    }
  };

  const verified = user && (user.emailVerified || user.providerData.some(p => p.providerId === "microsoft.com"));

  return (
    <>
      {user && !verified && (
        <div className="danger-bar">
          <Container>
            {sent ? (
              <div>
                The verification email has been sent to {user.email}. Please
                check your inbox and the junk folder.
              </div>
            ) : clicked ? (
              <div>Sending verification email to {user.email}.</div>
            ) : (
              <div>
                Your information will not be listed on the directory until your
                email has been verified. Please verify your email, or&nbsp;
                <span className="link-normal" onClick={handleClick}>
                  Resend Verification Email
                </span>
                . Note that it might appear in the junk folder.
              </div>
            )}
          </Container>
        </div>
      )}
    </>
  );
};

export default DangerBar;
